<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-align-horizontal-centers`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M26 5c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v6h-8a1 1 0 00-1 1v8a1 1 0 001 1h8v6H7a1 1 0 00-1 1v8a1 1 0 001 1h15v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6h15a1 1 0 001-1v-8a1 1 0 00-1-1H26v-6h8a1 1 0 001-1v-8a1 1 0 00-1-1h-8V5z"/></svg>
</template>
<script>

export default {
  name: 'IconAlignHorizontalCenters',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
